import { render, staticRenderFns } from "./ELayoutBoletim.vue?vue&type=template&id=00b8f81a&scoped=true"
import script from "./ELayoutBoletim.vue?vue&type=script&lang=js"
export * from "./ELayoutBoletim.vue?vue&type=script&lang=js"
import style0 from "./ELayoutBoletim.vue?vue&type=style&index=0&id=00b8f81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8f81a",
  null
  
)

export default component.exports